/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Adm_Where_ProductInputs */

const en_adm_where_product = /** @type {(inputs: Adm_Where_ProductInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`the product ${i?.name}`)
};

const de_adm_where_product = /** @type {(inputs: Adm_Where_ProductInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`das Produkt ${i?.name}`)
};

/**
* | output |
* | --- |
* | "the product {name}" |
*
* @param {Adm_Where_ProductInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const adm_where_product = /** @type {((inputs: Adm_Where_ProductInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Adm_Where_ProductInputs, { locale?: "en" | "de" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_adm_where_product(inputs)
	return en_adm_where_product(inputs)
});